export const baseReset = {
    all: 'unset',
    display: 'revert',
    boxSizing: 'border-box',
};
export const boxSizing = {
    boxSizing: 'border-box',
};
export const listReset = {
    boxSizing: 'border-box',
    listStyle: 'none',
    margin: 0,
    padding: 0,
};
export const interactiveReset = Object.assign(Object.assign({}, baseReset), { cursor: 'pointer' });
//# sourceMappingURL=reset.js.map
// @zapier/universal-layout@11.0.65 (44a58cc23)
